import React, { useRef } from 'react';
import ListItem from '../../general/list/ListItem';
import { generateId } from '../../../misc/misc';
import { DragItemType } from '../../share/dnd/DragItemType';
import { useDrop } from 'react-dnd';
import { cx } from '../../../api';
import Intent from '../../../misc/ObjectActionIntent';
import { className, fromProps } from '../../../lib/className';

/**
 * @param {Object} props
 * @param {cx.ods.processors.FuelLevelProcessor} props.processor
 * @param {function} props.onSelect
 * @param {function} props.onIntent
 */

function FuelProcessorListItem(props) {
	const uid = useRef(generateId());

	const onClick = () => {
		props.onSelect(props.processor);
	}

	const onDrop = (item) => {
		if (item.type == DragItemType.ACTION_EDIT) {
			props.onIntent(new Intent(null, Intent.Action.Edit, props.processor));
		} else {
			const offset = cx.dom.at.offset(document.getElementById(uid.current));
			props.onIntent(new Intent(null, Intent.Action.Remove, props.processor, { offset }));
		}
	}

	const [dropState, dropRef] = useDrop({
		accept: [DragItemType.ACTION_EDIT, DragItemType.ACTION_REMOVE],
		drop: (item) => onDrop(item),
		collect: monitor => ({
			isOver: monitor.isOver(),
			canDrop: monitor.canDrop()
		})
	});

	return (
		<ListItem
			customRef={dropRef}
			className={className(fromProps(props), { 'droppable':  dropState.isOver && dropState.canDrop })}
			onClick={onClick}
			id={uid.current}
		>
			{props.processor.name}
		</ListItem>
	);
}

export default FuelProcessorListItem;